// extracted by mini-css-extract-plugin
module.exports = {"header":"header-module--header--1_uI8","logo":"header-module--logo--2GIq_"};